import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface MasqueradeState {
  userId: number | null;
  userDisplay: string | null; // e.g. name/email for UI feedback
}

const initialState: MasqueradeState = {
  userId: null,
  userDisplay: null,
};

const masqueradeSlice = createSlice({
  name: 'masquerade',
  initialState,
  reducers: {
    startMasquerade(state, action: PayloadAction<{ userId: number; userDisplay: string }>) {
      state.userId = action.payload.userId;
      state.userDisplay = action.payload.userDisplay;
    },
    stopMasquerade(state) {
      state.userId = null;
      state.userDisplay = null;
    },
  },
});

export const { startMasquerade, stopMasquerade } = masqueradeSlice.actions;
export default masqueradeSlice.reducer;
